import type {CopilotSpace} from '@github-ui/copilot-chat-types'
import {SlidersIcon} from '@primer/octicons-react'
import {useRef, useState} from 'react'

import {InstructionsDialog} from './InstructionsDialog'
import styles from './SpaceInstructions.module.css'

interface SpaceInstructionsProps {
  copilotSpace: CopilotSpace
  onSave: (instructions: string) => Promise<CopilotSpace>
  onSaved?: (updatedSpace: CopilotSpace) => void
  isSaving: boolean
}

export function SpaceInstructions({copilotSpace, onSave, onSaved, isSaving}: SpaceInstructionsProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <button
        ref={buttonRef}
        className={styles.instructions}
        onClick={() => setIsDialogOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={isDialogOpen}
      >
        <div className={styles.instructionsHeader}>
          <SlidersIcon size={16} className={styles.instructionsIcon} />
          <h2 className={styles.instructionsTitle}>Instructions</h2>
        </div>
        {copilotSpace.generalInstructions ? (
          <p className={styles.instructionsContent}>{copilotSpace.generalInstructions}</p>
        ) : (
          <p className={styles.instructionsEmptyState}>
            Define Copilot’s role, focus, and what to avoid in this space. Ex. “You are a [role]. Follow our
            [framework/patterns] to [type of task]. Avoid [practices or tools] unless specified”.
          </p>
        )}
      </button>
      {isDialogOpen && (
        <InstructionsDialog
          copilotSpace={copilotSpace}
          onClose={() => setIsDialogOpen(false)}
          returnFocusRef={buttonRef}
          onSave={onSave}
          onSaved={onSaved}
          isSaving={isSaving}
        />
      )}
    </>
  )
}
